import React, { Component } from "react";
import axios from "axios";
import { Card, Row, Col, Alert } from "react-bootstrap";
import { Bar, Pie } from "react-chartjs-2";
import CartContext from "./CartContext";

export default class PurchaseOrderDashboard extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      summary: null,
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    this.loadSummary();
  }

  async loadSummary() {
    try {
      const { storeId } = this.context;
      const res = await axios.get(
        `${process.env.REACT_APP_API}ProductPurchaseDashboard/Summary/${storeId}`
      );
      this.setState({ summary: res.data, loading: false });
    } catch (err) {
      console.error(err);
      this.setState({
        error: "Failed to load purchase order dashboard",
        loading: false,
      });
    }
  }

  render() {
    const { summary, loading, error } = this.state;

    if (loading)
      return <Alert variant="info">Loading purchase order dashboard...</Alert>;
    if (error) return <Alert variant="danger">{error}</Alert>;
    if (!summary || summary.message)
      return <Alert variant="warning">{summary?.message || "No data"}</Alert>;

    // ✅ Chart Data
    const monthlyChartData = {
      labels: summary.monthlySpend.map((m) => m.month),
      datasets: [
        {
          label: "Monthly Spend",
          data: summary.monthlySpend.map((m) => m.value),
          backgroundColor: "rgba(75,192,192,0.6)",
        },
      ],
    };

    const supplierChartData = {
      labels: summary.supplierWise.map((s) => s.supplier ?? s.Supplier), // 👈 fix casing
      datasets: [
        {
          label: "Supplier Spend",
          data: summary.supplierWise.map((s) => s.value ?? s.Value), // 👈 fix casing
          backgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#4BC0C0",
            "#9966FF",
          ],
        },
      ],
    };

    return (
      <div className="container mt-3">
        <h3>Purchase Order Dashboard</h3>

        {/* Summary Cards */}
        <Row className="mb-3">
          <Col md={3}>
            <Card className="p-3 shadow-sm">
              <h6>Total Orders</h6>
              <h4>{summary.totalOrders}</h4>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="p-3 shadow-sm">
              <h6>Total Value</h6>
              <h4>₹ {summary.totalValue.toFixed(2)}</h4>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="p-3 shadow-sm">
              <h6>Paid Amount</h6>
              <h4>₹ {summary.totalPaid.toFixed(2)}</h4>
            </Card>
          </Col>
          <Col md={3}>
            <Card className="p-3 shadow-sm">
              <h6>Pending Amount</h6>
              <h4>₹ {summary.pendingAmount.toFixed(2)}</h4>
            </Card>
          </Col>
        </Row>

        {/* Charts */}
        <Row>
          <Col md={6}>
            <Card className="p-3 shadow-sm mb-3">
              <h6>Monthly Purchase Trend</h6>
              <Bar data={monthlyChartData} />
            </Card>
          </Col>
          <Col md={6}>
            <Card className="p-3 shadow-sm mb-3">
              <h6>Supplier-wise Spend</h6>
              <Pie data={supplierChartData} />
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}
